module.exports = __webpack_public_path__ + "img/teacher3.c684ccc4.svg";